module.exports = __webpack_public_path__ + "media/images/flags/ge-98cf9dc189b05e67103c0dcff4b7a982.svg";